import {defineStore} from 'pinia'
import userService from "../services/user.service";

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    user: {}
  }),
  getters: {
    get: (state) => state.user,
    isLoggedin: (state) => state.user && !!state.user.id,
    isReception: (state) => state.user && state.user.role >= 2,
    isTeamlead: (state) => state.user && state.user.role >= 3,
    isAdmin: (state) => state.user && state.user.role >= 4
  },
  actions: {
    set(user) {
      this.user = user;
    },
    async getMe() {
      try {
        let res = await userService.getMe();
        this.user = res.data;
      } catch (e) {
        console.log(e);
      }
    },
    async logout() {
      await userService.logout();
      this.user = {}
    },
    confirmEmail() {
      this.user.email_confirmed = true;
    }
  }
})
